import { devices, margins, sizes, content, devicesNovo, marginsNovo } from "./_variables.styled";

export const grid = (string: "" | "small") => `
    & > * {
        width: 100%;
        max-width: ${string === "small" ? content.desktopSmall : content.desktop}px;
        margin-left: auto;
        margin-right: auto;
    }

    @media ${devices.desktop} {
        margin: 0 auto;
        padding-left: ${margins.desktop}px;
        padding-right: ${margins.desktop}px;
    }
    
    @media ${devices.tablet} {
        padding-left: ${margins.tablet}px;
        padding-right: ${margins.tablet}px;
    }
    
    @media ${devices.mobile} {
        padding-left: ${margins.mobile}px;
        padding-right: ${margins.mobile}px;
    }   
`;


export const gridNovoConhecer = (string: "" | "small") => `
    & > * {
        width: 100%;
        max-width: ${string === "small" ? content.desktopSmall : content.desktop}px;
        margin-left: auto;
        margin-right: auto;
    }

    @media ${devicesNovo.desktop} {
        margin: 0 auto;
        padding-left: ${marginsNovo.desktop}px;
        padding-right: ${marginsNovo.desktop}px;
    }
    
    @media ${devicesNovo.tablet} {
        padding-left: ${marginsNovo.tablet}px;
        padding-right: ${marginsNovo.tablet}px;
    }
    
    @media ${devices.mobile} {
        padding-left: ${marginsNovo.mobile}px;
        padding-right: ${marginsNovo.mobile}px;
    }   
`;

//usage: grid()
//grid("small")


// usage: {grid}
